import { DebouncedFunc } from 'lodash';
import debounce from 'lodash/debounce';
import { TIME_DEBOUNCE_CALL_API } from '../constants';

const debounceFunc = (func: any, timeCall = TIME_DEBOUNCE_CALL_API): DebouncedFunc<any> => {
  return debounce(func, timeCall);
};

export default debounceFunc;
